/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable sonarjs/cognitive-complexity */
import React, { useEffect, useState } from 'react';
import SiteWrapper from 'components/SiteWrapper/SiteWrapper';
import { RefreshFormComponent } from 'components/RefreshFormComponent/RefreshFormComponent';
import { connect, useSelector } from 'react-redux';
import { formatDate, formatDateToUTC } from 'helpers/DateFormatter';
import { useMsal } from '@azure/msal-react';
import PropTypes from 'prop-types';
import { isMobile as isTablet } from 'react-device-detect';
import {
    Trim, MatchSRA, checkURVGreaterThanLRV, MatchOldTRFs, TestPointRange,
    displayPopUpMessage, checkTGCGreaterThanSetpointHH, checkTGCLessThanSetpointLL,
    conditionalValueSelector, icEngApprovedValueYes
} from 'helpers/Validation';
import imageStore from 'utils/ImageDB';
import { values, clear } from 'idb-keyval';
import { notRequiredVal } from './Sections';
import Camera from 'components/Camera/Camera';
import { captureTRFImageHandler } from 'helpers/FormHelpers/helper';
import { setCurrentView } from 'journeys/portal/Home/Home.actions';
import AlertDialog from 'components/DialogComponent/AlertDialog';
import {
    GetITFForm, submitNewFormOnlineOrOffline, submitExistingFormOnlineOrOffline,
    resetFormData, submitImagesOnlineOrOffline, deleteImagesFromDB,
    deleteImagesFromLocalDB, UpdateFormDataObj,
    updateImageNote, setIsEditimage, clearEditImageList,
    saveAftTestPointRangePrevVal, saveAltTestPointRangePrevVal,
    saveFlowAlarmTestPointRangePrevVal,
    saveSpinnerVisibleData,
    fetchDPSDataLateEntry,
    clearLateEntryTrfList,
    setSelectedTRF,
    getLateEntryTrfList,
    setLateEntryDPSData
} from './Forms.actions';
import { setP81FormData, setSRAFormData, GetP8ITFForm, getAllP8MOImages } from './FormsP8.actions';
import { buildDataObject, areFilledAllMandatoryDataObject } from './FormHelpers/ParsedForm.data';
import { MRAT_USER_ROLE } from '../Home/Home.constants';
import { submitP8Forms } from './FormHelpers/submitP8Forms';
import { submitNewTRFImage, updateExistingTRFImage, submitNewP8TRFImage, updateExistingP8TRFImage, submitP8Image } from './TRFImaging.actions';
import { getAltDeleteIconStatus, hideAltDeleteIcons, showAltDeleteIcons } from './Sections/AsLeftTestTableSection/AsLeftTestTableSection.helpers';
import { getAftDeleteIconStatus, hideAftDeleteIcons, showAftDeleteIcons } from './Sections/AsFoundTestTableSection/AsFoundTestTableSection.helpers';
import { showFlowAlarmDeleteIcons } from './Sections/FlowAlarmTest/FlowAlarmTest.helpers';
import { Spinner, DarkBackground } from 'elements/Spinner/Spinner.styled';
import _ from 'lodash';
import { DraftAlert } from './FormHelpers/DraftAlert';
import { colorLegendForm, formDataCalculatedFieldsName } from './Forms.data';
import { handleFormPrint } from './FormHelpers/PrintForm';
import { getTestMakeModelData, searchTestEquipment } from '../TestEquipment/TestEquipment.actions';
import { setPreviousScreen } from '../Home/Home.actions';

const Form = (props) => {
    const { dispatch, deleteExistingImageList, loadITFForm, selectedTag, formData, formDataSRA, dpsData,
        saveP81FormData, saveSRAFormData, testMakeModelData, setCurrentAppView, selectedTrfId, currentView,
        formDataP81, userRole, clearEditimageList, resetFormDataValues, formName, totalCount, editedImageList,
        loadP8ITFForm, deleteNewImageList, setIsEditImages, saveNewFormOnlineOrOffline, saveExistingFormOnlineOrOffline, saveTRFImage,
        trfFormImage, updateTRFImage, updateimageNote, saveP8TRFImage, updateP8TRFImage, setPreviousAppScreen,
        workType, saveUpdatedFormDataObj, updateAftTestPointRangePrevVal, draftStatus, sortColumn, sortDeviceTypeAscOrder, sortStatusAscOrder,
        fetchTestEquipmentData, searchStringForTestEq, searchTestEquipmentRecords, setSortedTestEquipmentView,
        flowAlarmTestPoint, updateFlowAlarmTestPointRangePrevVal, isMRATOnline, draftDuration,
        updateAltTestPointRangePrevVal, setSpinnerVisible, spinnerVisible, bpRegionNameAlias,
        aftTestPoint, altTestPoint, trfMasterList, multiTRFDetails, selectedAssetAliasName, updatedFormDataTag, previousScreen, updatedFormDataObj, IsLateEntry, dpsSelectedFormData, dpsDataAll, isLateEntrySaflocExist, isLateEntrylastFlowDate, isLateEntryInvalidTrf, isLateEntryTrfAlredySubmited, lateEntrySwitchData
    } = props;
    const getTimestamp = () => {
        const dt = selectedTag?.currentDateTime
            ? new Date(selectedTag.currentDateTime)
            : new Date();
        const pad = (n) => n.toString().padStart(2, '0');
        return `${pad(dt.getDate())}${pad(dt.getMonth() + 1)}${dt.getFullYear()}${pad(dt.getHours())}${pad(dt.getMinutes())}${pad(dt.getSeconds())}`;
    };
    const { instance } = useMsal();
    const userName = instance.getActiveAccount();
    const [trfLongDesc, setTrfLongDesc] = useState('');
    const [trfShortDesc, setTrfShortDesc] = useState('');
    const [enableDraftButton, setEnableDraftButton] = useState(false);
    const [showDraftAlert, setShowDraftAlert] = useState(false);
    const [showTagMoExist, setShowTagMoExist] = useState(false);
    const [showTagMoNotExist, setShowTagMoNotExist] = useState(false);
    const [displayForm, setDisplayForm] = useState(true);
    const [capturedImages, setCapturedImages] = useState([]);
    const [deleteWarning, setDeleteWarning] = useState(false);
    const [uniqueMoNumber] = useState(getTimestamp());
    const [showDpsTfrSwitchAlert, setShowDpsTfrSwitchAlert] = useState(false);
    const [selectDpsTRFDataLateEntry, setSelectDpsTRFDataLateEntry] = useState('');
    const nullChecker = (firstValue, secondValue) => firstValue ?? secondValue;
    const newTrfId = nullChecker(selectedTrfId, Trim(selectedTag.TrfId));
    const currentTrfId = Trim(selectedTag.TrfId);
    const widerFooter = '5rem';
    const isNonMoFeatureEnabled = useSelector(({ Home }) => Home.isNonMoFeatureEnabled);
    const buildDataObjectFunction = (_formData) => buildDataObject({
        selectedTag,
        userName,
        dpsData,
        distinctTestMakeModelData: testMakeModelData,
        formName,
        _formData,
        selectedTrfId,
        aftTestPoint,
        altTestPoint,
        flowAlarmTestPoint,
        multiTRFDetails,
        formDataSRA,
        isNonMoFeatureEnabled,
        IsLateEntry,
        bpRegionNameAlias
    });
    const initialFormData = buildDataObjectFunction(formData);
    const [formDataInitialState, setFormDataInitialState] = useState(initialFormData);
    const [formDataObj, setFormDataObj] = useState(updatedFormDataObj);
    const allMandatoryFieldsAreFilled = (_formData) => areFilledAllMandatoryDataObject({
        selectedTag,
        userName,
        dpsData,
        distinctTestMakeModelData: testMakeModelData,
        formName,
        _formData,
        selectedTrfId,
        aftTestPoint,
        altTestPoint,
        flowAlarmTestPoint,
        multiTRFDetails,
        formDataSRA,
        isNonMoFeatureEnabled,
        IsLateEntry,
        bpRegionNameAlias
    });
    const getImages = () => values(imageStore).then((val) => setCapturedImages([...val]));
    const isTRFP720P721 = ['P7-20', 'P7-21', 'M6-10', 'P6-26'].includes(newTrfId);
    const noOfRows = conditionalValueSelector(newTrfId === 'M6-10', 8, 10);
    const validTPRange = conditionalValueSelector(newTrfId === 'M6-10',
        formDataObj?.F376CleanDetectorLensesIfVisiblyDirty !== notRequiredVal,
        formDataObj.F102AftResult !== 'PASS');
    const trfDesc = trfMasterList.find((data) => data.TrfId === currentView);
    const nonMoTestEquipmentScreen = previousScreen === 'testequipment';

    useEffect(() => {
        const trfTitleList = multiTRFDetails?.find((data) => data.TrfmasterId === currentView && data.Trftag === formDataObj.F956TrfTypeSelection);
        const newTrfLongDesc = nullChecker(trfTitleList?.Trftitle, trfDesc?.TrfLongDesc);
        const newTrfShortDesc = nullChecker(trfTitleList?.TrfShortDesc, trfDesc?.TrfShortDesc);
        setTrfLongDesc(newTrfLongDesc);
        setTrfShortDesc(newTrfShortDesc);
    }, [multiTRFDetails, formDataObj.F956TrfTypeSelection]);
    const headerText = (
        isNonMoFeatureEnabled || IsLateEntry ? (
            <div style={{ textAlign: 'center' }}>
                {`${currentView} ${trfLongDesc}`}
            </div>
        ) : (
            <div style={{ textAlign: 'center' }}>
                {`${currentView} ${trfLongDesc}`}
                <br />
                MO
                {' '}
                {selectedTag.HdWorkOrder}
                <br />
                {conditionalValueSelector(workType.toLowerCase() !== 'corrective',
                    `MI ${selectedTag.Mi}`,
                    '')}
            </div>
        )
    );
    const changeHandler = (field) => {
        if (IsLateEntry) {
            dispatch(fetchDPSDataLateEntry(field?.F2SapFloc));
        }
        if (isTRFP720P721 && !deleteWarning && !getAltDeleteIconStatus() && !getAftDeleteIconStatus()) {
            blurHandler(field);
        }
        setFormDataObj(currentFormDataObj => {
            const updatedFormData = { ...currentFormDataObj, ...field };
            saveUpdatedFormDataObj(updatedFormData);
            return updatedFormData;
        });
    };
    const sectionHandlers = {
        Aft: {
            func: showAftDeleteIcons,
            testPointNumber: aftTestPoint,
            updateFunc: updateAftTestPointRangePrevVal,
            formDataKey: 'F675NumberOfTestPoints'
        },
        Alt: {
            func: showAltDeleteIcons,
            testPointNumber: altTestPoint,
            updateFunc: updateAltTestPointRangePrevVal,
            formDataKey: 'F721NumberOfTestPoints'
        },
        flowAlarm: {
            func: showFlowAlarmDeleteIcons,
            testPointNumber: flowAlarmTestPoint,
            updateFunc: updateFlowAlarmTestPointRangePrevVal,
            formDataKey: 'F816NumberOfTestPoints'
        }
    };
    const blurHandler = (field) => {
        const fieldName = Object.keys(field)[0];
        const fieldValue = Object.values(field)[0];
        const handler = Object.values(sectionHandlers).find(({ formDataKey }) => formDataKey === fieldName);
        if (handler && TestPointRange(fieldValue, noOfRows)) {
            handler.updateFunc(handler.testPointNumber);
            setDeleteWarning(displayPopUpMessage(fieldValue, handler.testPointNumber, noOfRows));
            if (!displayPopUpMessage(fieldValue, handler.testPointNumber, noOfRows)) {
                handler.updateFunc(fieldValue);
            }
        }
    };
    let tgcAftError = true;
    let tgcAltError = true;
    if (['M6-1', 'M6-11', 'M6-14'].includes(newTrfId)) {
        tgcAftError = checkTGCGreaterThanSetpointHH(formDataObj?.F240HighHighSetpoint, formDataObj?.F424AftAppliedTestGasConcentration);
        tgcAltError = checkTGCGreaterThanSetpointHH(formDataObj?.F240HighHighSetpoint, formDataObj?.F426AltAppliedTestGasConcentration);
    } else if (newTrfId === 'M6-15') {
        tgcAftError = checkTGCLessThanSetpointLL(formDataObj?.F241LowLowSetpoint, formDataObj?.F424AftAppliedTestGasConcentration);
        tgcAltError = checkTGCLessThanSetpointLL(formDataObj?.F241LowLowSetpoint, formDataObj?.F426AltAppliedTestGasConcentration);
    }
    const URVGreaterThanLRVError = checkURVGreaterThanLRV(formDataObj.F21HmiLrv, formDataObj.F22HmiUrv);
    const validNumberOfTP = conditionalValueSelector(validTPRange, TestPointRange(formDataObj.F675NumberOfTestPoints, noOfRows)
        && TestPointRange(formDataObj.F721NumberOfTestPoints, noOfRows),
        TestPointRange(formDataObj.F675NumberOfTestPoints, noOfRows));
    const RangeOfTestPoints = conditionalValueSelector(isTRFP720P721, validNumberOfTP, true);
    const InstrumentURVGreaterThanLRVError = checkURVGreaterThanLRV(formDataObj.F25InstrumentLrv, formDataObj.F26InstrumentUrv);
    const InstCalibratedURVGreaterThanLRVError = conditionalValueSelector(MatchOldTRFs(newTrfId), true,
        checkURVGreaterThanLRV(formDataObj.F116InstrumentCalibratedLrv, formDataObj.F117InstrumentCalibratedUrv));
    const HasICengapprovedvalue = icEngApprovedValueYes(formDataObj.F964HasIandCEngApproved);
    const [disableSubmit, setDisableSubmit] = useState(false);
    const isFormExisting = formDataObj.RowId;
    const getCapturedImg = capturedImages.filter((img) => img.HdLocation === (selectedTag.HdLocation || updatedFormDataTag.F2SapFloc)
        && img.HdWorkOrder === (selectedTag.HdWorkOrder || formDataObj.F20Mo || uniqueMoNumber));
    const updateFormData = (key, arraykeys, section) => {
        let updatedFormData = formDataObj;
        const handler = sectionHandlers[section];
        const { func, testPointNumber, updateFunc, formDataKey } = handler;
        for (let i = Number(key); i <= Number(testPointNumber); i += 1) {
            updatedFormData = arraykeys.reduce((acc, arrayKey) => ({
                ...acc,
                [`${arrayKey}${i}`]: acc[`${arrayKey}${i + 1}`]
            }), { ...updatedFormData });
        }
        setFormDataObj(buildDataObjectFunction(updatedFormData));
        const resetPrevValues = func(formDataObj?.[formDataKey], Number(testPointNumber) - 1);
        updateFunc(Number(testPointNumber) - 1);
        if (!resetPrevValues) {
            updateFunc(formDataObj?.[formDataKey]);
        }
    };
    const uniqueFormName = `${selectedTag.Mi ?? ''}_${selectedTag.HdWorkOrder || formDataObj.F20Mo || uniqueMoNumber}_${selectedTag.HdLocation ?? updatedFormDataTag.F2SapFloc}`;
    useEffect(() => {
        if (nonMoTestEquipmentScreen) return;
        setSpinnerVisible(true);
        const { HdLocation } = selectedTag;
        getImages();
        const dummyObj = currentView === 'P8-1' ? formDataP81 ?? undefined : formDataSRA;
        if (MatchSRA(Trim(newTrfId))) {
            loadP8ITFForm({ uniqueFormName, HdLocation, currentTrfId })
                .then((result) => {
                    setFormDataInitialState(() => _.isEmpty(dummyObj) ? buildDataObjectFunction(result) : dummyObj);
                    setFormDataObj(_.isEmpty(dummyObj) ? buildDataObjectFunction(result) : dummyObj);
                })
                .finally(() => setSpinnerVisible(false));
        } else {
            loadITFForm({ uniqueFormName, HdLocation, currentTrfId })
                .then((resultFormData) => {
                    hideAftDeleteIcons();
                    hideAltDeleteIcons();
                    setFormDataInitialState(() => buildDataObjectFunction(resultFormData));
                    setFormDataObj(() => buildDataObjectFunction(resultFormData));
                })
                .finally(() => setSpinnerVisible(false));
        }
        resetFormDataValues();
        setSpinnerVisible(false);
    }, []);
    const [callbackTriggered, setCallbackTriggered] = useState(false);
    useEffect(() => {
        if (callbackTriggered) {
            buttonHandler();
            setCallbackTriggered(false); // Reset the callback trigger
        }
    }, [callbackTriggered]);

    const submitButtonHandler = () => {
        if (selectedTag?.InDraftState) {
            const draftObj = {
                Mo: selectedTag.HdWorkOrder,
                Mi: selectedTag.Mi,
                Floc: selectedTag.HdLocation,
                InDraftState: false
            };
            setFormDataObj(currentFormDataObj => {
                const tempObj = { ...currentFormDataObj, draftTrackingData: draftObj, InDraftState: false, IsNonMoTrf: false, IsLateEntry: false };
                setCallbackTriggered(true);
                return tempObj;
            });
        } else if (isNonMoFeatureEnabled || IsLateEntry) {
            let nonMoObject = {};
            const moValue = selectedTag.HdWorkOrder || formDataObj.F20Mo || formDataSRA.F20Mo || uniqueMoNumber;
            if (isFormExisting) {
                nonMoObject = {
                    Region: bpRegionNameAlias.toUpperCase(),
                    Asset: selectedAssetAliasName.toUpperCase(),
                    HdLocation: formDataObj.F2SapFloc,
                    MO: selectedTag.HdWorkOrder,
                    LastModifiedBy: userName?.name,
                    LastModifiedDate: formatDate(selectedTag.currentDateTime),
                    LastModifiedDateUtc: formatDateToUTC(selectedTag.currentDateTime),
                    LastModifiedDeviceType: isTablet ? 'Tablet' : 'Laptop',
                    LastModifiedWifiState: isMRATOnline ? 'Online' : 'Offline',
                    LastModifiedByEmail: userName?.username,
                };
            } else {
                nonMoObject = {
                    Region: bpRegionNameAlias.toUpperCase(),
                    Asset: selectedAssetAliasName.toUpperCase(),
                    TrfId: newTrfId,
                    TrfformTitle: trfLongDesc,
                    TrfshortDesc: trfShortDesc,
                    HdLocation: formDataObj.F2SapFloc,
                    MO: moValue,
                    CreatedBy: userName?.name,
                    CreatedDate: formatDate(selectedTag.currentDateTime),
                    CreatedDateUtc: formatDateToUTC(selectedTag.currentDateTime),
                    CreatedWifiState: isMRATOnline ? 'Online' : 'Offline',
                    CreatedDeviceType: isTablet ? 'Tablet' : 'Laptop',
                    LastModifiedBy: userName?.name,
                    LastModifiedDate: formatDate(selectedTag.currentDateTime),
                    LastModifiedDateUtc: formatDateToUTC(selectedTag.currentDateTime),
                    LastModifiedDeviceType: isTablet ? 'Tablet' : 'Laptop',
                    LastModifiedWifiState: isMRATOnline ? 'Online' : 'Offline',
                    LastModifiedByEmail: userName?.username,
                    IsLateEntry: !!IsLateEntry,
                    IsNonMoTrf: isNonMoFeatureEnabled,
                };
            }
            setFormDataObj(currentFormDataObj => {
                const tempObj = {
                    ...currentFormDataObj,
                    nonMoObjectData: nonMoObject,
                    InDraftState: false,
                    IsLateEntry: !!IsLateEntry,
                    IsNonMoTrf: isNonMoFeatureEnabled,
                    F92RegionDocId: bpRegionNameAlias,
                    F20Mo: moValue,
                };
                setCallbackTriggered(true);
                return tempObj;
            });
        } else {
            setFormDataObj(currentFormDataObj => {
                const tempObj = { ...currentFormDataObj, InDraftState: false, IsNonMoTrf: false, IsLateEntry: false };
                setCallbackTriggered(true);
                return tempObj;
            });
        }
    };
    const draftButtonHandler = () => {
        setShowDraftAlert(true);
    };
    const draftHandler = (notice) => {
        setShowDraftAlert(false);
        const draftObj = {
            Region: bpRegionNameAlias.toUpperCase(),
            Asset: selectedAssetAliasName.toUpperCase(),
            TrfId: newTrfId,
            TrfformTitle: trfLongDesc,
            Mo: selectedTag.HdWorkOrder,
            Mi: selectedTag.Mi,
            Floc: selectedTag.HdLocation,
            InDraftState: true,
            ReasonForDraft: notice,
            TimeInDraftAllowed: draftDuration
        };
        let draftDataObj = { ...draftObj };
        if (isFormExisting && selectedTag.InDraftState) {
            draftDataObj = {
                ...draftObj,
                LastModifiedBy: userName?.name,
                LastModifiedDate: formatDate(selectedTag.currentDateTime),
                LastModifiedDateUtc: formatDateToUTC(selectedTag.currentDateTime),
                LastModifiedDeviceType: isTablet ? 'Tablet' : 'Laptop',
                LastModifiedWifiState: isMRATOnline ? 'Online' : 'Offline',
                LastModifiedByEmail: userName?.username
            };
        } else {
            draftDataObj = {
                ...draftObj,
                CreatedBy: userName?.name,
                CreatedDate: formatDate(selectedTag.currentDateTime),
                CreatedDateUtc: formatDateToUTC(selectedTag.currentDateTime),
                CreatedWifiState: isMRATOnline ? 'Online' : 'Offline',
                CreatedDeviceType: isTablet ? 'Tablet' : 'Laptop',
                LastModifiedBy: userName?.name,
                LastModifiedDate: formatDate(selectedTag.currentDateTime),
                LastModifiedDateUtc: formatDateToUTC(selectedTag.currentDateTime),
                LastModifiedDeviceType: isTablet ? 'Tablet' : 'Laptop',
                LastModifiedWifiState: isMRATOnline ? 'Online' : 'Offline',
                LastModifiedByEmail: userName?.username
            };
        }
        setFormDataObj(currentFormDataObj => {
            const tempObj = { ...currentFormDataObj, draftTrackingData: draftDataObj, InDraftState: true, IsNonMoTrf: false, IsLateEntry: false };
            setCallbackTriggered(true);
            return tempObj;
        });
    };

    const handleImageCapture = async () => {
        const moValue = selectedTag.HdWorkOrder || formDataObj.F20Mo || formDataSRA.F20Mo || uniqueMoNumber;
        const imgCanvas = await captureTRFImageHandler(userName?.name, formatDate(selectedTag.currentDateTime), moValue);
        return imgCanvas.toDataURL('image/png');
    };

    const handleP8FormSubmission = (isTRFImageCaptured, imageData, imgNonMoState, imgLateEntryState) => {
        const newFormedObjectP81 = _.cloneDeep(formDataObj);
        conditionalValueSelector(
            isTRFImageCaptured ?? selectedTag?.InDraftState,
            () => updateP8TRFImage(imageData, userName, uniqueFormName, imgNonMoState, imgLateEntryState),
            () => saveP8TRFImage(imageData, userName, uniqueFormName, imgNonMoState, imgLateEntryState)
        )();
        const p8FormsObj = {
            formDataSRA,
            formDataObj,
            newFormedObjectP81,
            userName,
            selectedTag,
            saveExistingFormOnlineOrOffline,
            saveNewFormOnlineOrOffline,
            uniqueFormName,
            newTrfId
        };
        submitP8Forms(p8FormsObj);
    };

    const handleFormSubmission = (isTRFImageCaptured, imageData, imgDraftState, imgNonMoState, imgLateEntryState) => {
        let tempFormObj = _.cloneDeep(formDataObj);
        if (tempFormObj?.draftTrackingData) {
            const trackingData = { ...tempFormObj.draftTrackingData, InDraftImage1: imageData?.split(',')[1] };
            tempFormObj = _.cloneDeep({ ...tempFormObj, draftTrackingData: trackingData });
        }
        conditionalValueSelector(
            isTRFImageCaptured ?? selectedTag?.InDraftState,
            () => updateTRFImage(imageData, userName, uniqueFormName, imgDraftState, imgNonMoState, imgLateEntryState),
            () => saveTRFImage(imageData, userName, uniqueFormName, imgDraftState, imgNonMoState, tempFormObj?.F2SapFloc, imgLateEntryState)
        )();
        const newFormName = MatchSRA(Trim(newTrfId)) ? `${uniqueFormName}_SRA` : uniqueFormName;
        if (isFormExisting) {
            saveExistingFormOnlineOrOffline(newFormName, tempFormObj, newTrfId, userName);
            editedImageList.length !== 0 && updateimageNote();
            clearEditimageList();
        } else {
            saveNewFormOnlineOrOffline(newFormName, tempFormObj, newTrfId, userName);
        }
    };

    const handleImageDeletion = async () => {
        if (!(MatchSRA(currentView)) && !formDataObj?.InDraftState) {
            deleteNewImageList.length !== 0 && await dispatch(deleteImagesFromLocalDB(deleteNewImageList));
            dispatch(submitImagesOnlineOrOffline());
            deleteExistingImageList.length !== 0 && dispatch(deleteImagesFromDB(uniqueFormName, deleteExistingImageList));
        }
    };

    const buttonHandler = async () => {
        getImages();
        setDisableSubmit(true);
        saveUpdatedFormDataObj(formDataObj);
        const imgDraftState = formDataObj.InDraftState;
        const imgNonMoState = formDataObj.IsNonMoTrf;
        const imgLateEntryState = formDataObj.IsLateEntry;
        const imgData = await handleImageCapture();
        const isTRFImageCaptured = trfFormImage.find((data) => data.TrfId === selectedTag.TrfId.trim()
            && data.HdLocation === selectedTag.HdLocation && data.Mi === (selectedTag.Mi ?? null) && data.HdWorkOrder === (selectedTag.HdWorkOrder));
        if (MatchSRA(currentView) && !formDataObj?.InDraftState) {
            saveSRAFormData(formDataObj);
            await submitP8Image(imgData);
            setCurrentAppView('P8-1');
        } else if (currentView === 'P8-1' && MatchSRA(Trim(newTrfId))) {
            handleP8FormSubmission(isTRFImageCaptured, imgData, imgNonMoState, imgLateEntryState);
        } else {
            handleFormSubmission(isTRFImageCaptured, imgData, imgDraftState, imgNonMoState, imgLateEntryState);
        }

        await handleImageDeletion();
    };
    const openCameraHandler = () => {
        getImages();
        setDisplayForm(false);
    };
    const closeCameraHandler = () => setDisplayForm(true);
    const switchSRAForm = () => {
        saveP81FormData(formDataObj);
        setCurrentAppView(newTrfId.trim());
    };

    const customizer = (objValue, othValue, key) => {
        if (formDataCalculatedFieldsName.includes(key)) {
            return true;
        }
        if ([null, undefined, ''].includes(objValue) && [null, undefined, ''].includes(othValue)) {
            return true;
        }
        // Return undefined to let Lodash handle other comparisons
        return undefined;
    };
    useEffect(() => {
        if (draftStatus) {
            if (!_.isEqualWith(formDataObj, formDataInitialState, customizer)) {
                setEnableDraftButton(true);
            } else {
                setEnableDraftButton(false);
            }
        }
    }, [formDataObj]);

    const handleNo = () => {
        setDeleteWarning(false);
        Object.values(sectionHandlers).forEach(({ formDataKey, testPointNumber }) => {
            if (displayPopUpMessage(formDataObj?.[formDataKey], testPointNumber, noOfRows)) {
                changeHandler({ [formDataKey]: testPointNumber });
            }
        });
    };
    const handleYes = () => {
        Object.values(sectionHandlers).forEach(({ func, testPointNumber, formDataKey }) => {
            if (displayPopUpMessage(formDataObj?.[formDataKey], testPointNumber, noOfRows)) {
                func(formDataObj?.[formDataKey], testPointNumber);
            }
        });
        setDeleteWarning(false);
    };
    const resetButtonHandler = () => {
        const { HdLocation } = selectedTag;
        if (MatchSRA(Trim(newTrfId)) && currentView !== 'P8-1') {
            clear(imageStore);
            dispatch(getAllP8MOImages());
            loadP8ITFForm({ uniqueFormName, HdLocation, currentTrfId })
                .then((resultFormData) => setFormDataObj(buildDataObjectFunction(resultFormData)));
        } else if (MatchSRA(Trim(newTrfId)) && currentView === 'P8-1') {
            dispatch(getAllP8MOImages());
            loadP8ITFForm({ uniqueFormName, HdLocation, currentTrfId })
                .then((resultFormData) => setFormDataObj(buildDataObjectFunction(resultFormData)));
        } else {
            loadITFForm({ uniqueFormName, HdLocation, currentTrfId })
                .then((resultFormData) => {
                    setFormDataObj(buildDataObjectFunction(resultFormData));
                    hideAftDeleteIcons();
                    hideAltDeleteIcons();
                });
        }
        setIsEditImages(false, {});
        clearEditimageList();
    };
    const isLateEntryTRFReadonly = selectedTag?.DateTimeTested ? false : !isLateEntryInvalidTrf;
    const areAllFieldsFilled = allMandatoryFieldsAreFilled(formDataObj);
    const userHasAccessToSubmit = (MRAT_USER_ROLE.Technician === userRole);
    const isFormReadOnly = (MRAT_USER_ROLE.View === userRole) || (MRAT_USER_ROLE.Engineer === userRole && selectedTag?.TrfRowId) || (IsLateEntry && isLateEntryTRFReadonly);
    const nonMoBack = !areAllFieldsFilled ? 'home' : 'tagselectionnonmoscreen';
    const lateEntryGoBack = !areAllFieldsFilled ? 'lateEntryHome' : 'tagselectionnonmoscreen';
    let goBackValue = 'tagselectionmoscreen';
    if (isNonMoFeatureEnabled) {
        goBackValue = nonMoBack;
    } else if (IsLateEntry) {
        goBackValue = lateEntryGoBack;
    }
    const handlePrint = async () => {
        await handleFormPrint(setSpinnerVisible);
    };

    const testEquipmentButtonHandler = async () => {
        setPreviousAppScreen(currentView);
        setCurrentAppView('testequipment');
        await fetchTestEquipmentData();
        searchStringForTestEq && searchTestEquipmentRecords(searchStringForTestEq);
        sortColumn !== '' && (sortColumn === 'DeviceType'
            ? setSortedTestEquipmentView(sortColumn, sortDeviceTypeAscOrder)
            : setSortedTestEquipmentView(sortColumn, sortStatusAscOrder));
    };
    useEffect(() => {
        if (IsLateEntry && dpsSelectedFormData) {
            setFormDataObj(prev => ({
                ...prev,
                ...dpsSelectedFormData,
                F2SapFloc: prev.F2SapFloc || dpsSelectedFormData.F2SapFloc
            }));
        }
    }, [IsLateEntry, dpsSelectedFormData]);

    useEffect(() => {
        if (IsLateEntry && lateEntrySwitchData?.F2SapFloc && lateEntrySwitchData?.F20Mo) {
            dispatch(getLateEntryTrfList());
        }
    }, [IsLateEntry, lateEntrySwitchData]);

    useEffect(() => {
        if (IsLateEntry) {
            dispatch(clearLateEntryTrfList());
        }
    }, [currentView, selectedTrfId, IsLateEntry]);
    useEffect(() => {
        const isFormSubmitted = selectedTag?.DateTested || selectedTag?.CreatedDate;
        if (IsLateEntry && formDataObj?.F2SapFloc && !isFormSubmitted && currentView !== 'P8-1') {
            const matchDpsData = dpsDataAll.find(item => String(item.SapFloc).toLowerCase() === String(formDataObj.F2SapFloc).toLowerCase());
            if (matchDpsData && matchDpsData.TrfId !== currentView) {
                setSelectDpsTRFDataLateEntry(matchDpsData);
                setShowDpsTfrSwitchAlert(true);
            } else {
                setSelectDpsTRFDataLateEntry('');
                setShowDpsTfrSwitchAlert(false);
            }
        } else {
            setSelectDpsTRFDataLateEntry('');
            setShowDpsTfrSwitchAlert(false);
        }
    }, [IsLateEntry, formDataObj?.F2SapFloc, currentView, dpsDataAll]);
    const handleLateentryDpsNo = () => {
        setShowDpsTfrSwitchAlert(false);
    };
    const handleLateentryDpsYes = () => {
        setShowDpsTfrSwitchAlert(false);
        dispatch(setSelectedTRF(selectDpsTRFDataLateEntry.TrfId));
        dispatch(setLateEntryDPSData(IsLateEntry ? {
            F2SapFloc: formDataObj?.F2SapFloc,
            F20Mo: formDataObj?.F20Mo
        } : null));
        setCurrentAppView(selectDpsTRFDataLateEntry.TrfId);
    };
    const handleLateentryFlocMoExist = () => {
        setShowTagMoExist(false);
    };
    const handleLateentryFlocMoNotExist = () => {
        setShowTagMoNotExist(false);
    };
    useEffect(() => {
        if (IsLateEntry) {
            if (isLateEntrylastFlowDate) {
                setShowTagMoExist(true);
            } else if (isLateEntrySaflocExist || isLateEntryTrfAlredySubmited) {
                setShowTagMoNotExist(true);
            } else {
                setShowTagMoNotExist(false);
                setShowTagMoExist(false);
            }
        }
    }, [isLateEntrylastFlowDate, isLateEntrySaflocExist, IsLateEntry, isLateEntryTrfAlredySubmited]);
    return (
        <SiteWrapper
            headerText={headerText}
            formName={formName}
            titleFontSize="16pt"
            showOfflineFormsCount
            totalCount={totalCount}
            headerPrintButtonHandler={handlePrint}
            trfSelectionVisible={!selectedTag.DateTested && !selectedTag.CreatedDate && !(currentView === 'P8-1' && MatchSRA(newTrfId))}
            closeCameraButtonVisible={!displayForm}
            closeCameraHandler={closeCameraHandler}
            displayFormStatus={displayForm}
            openCameraButtonVisible={!(currentView === 'P8-1' && MatchSRA(newTrfId))}
            switchSRAForm={switchSRAForm}
            openCameraHandler={openCameraHandler}
            testEquipmentSection={
                (MRAT_USER_ROLE.Technician === userRole || MRAT_USER_ROLE.Engineer === userRole) && (currentView !== 'P8-1') && displayForm
                    ? testEquipmentButtonHandler
                    : undefined
            }
            ButtonSection={(displayForm && !isFormReadOnly) ? <RefreshFormComponent resetButtonHandler={resetButtonHandler} /> : ''}
            colorLegend={colorLegendForm}
            footerButtonHandler={submitButtonHandler}
            draftButtonHandler={draftButtonHandler}
            printButtonVisible={displayForm}
            draftButtonVisible={enableDraftButton && (isFormExisting ? selectedTag.InDraftState : true) && draftStatus && !areAllFieldsFilled && URVGreaterThanLRVError
                && InstrumentURVGreaterThanLRVError && InstCalibratedURVGreaterThanLRVError && RangeOfTestPoints && tgcAftError && tgcAltError && HasICengapprovedvalue
                && userHasAccessToSubmit && !getAltDeleteIconStatus() && !getAftDeleteIconStatus() && currentView !== 'P8-1'}
            FooterButtonVisible={areAllFieldsFilled && URVGreaterThanLRVError
                && InstrumentURVGreaterThanLRVError && InstCalibratedURVGreaterThanLRVError && RangeOfTestPoints && tgcAftError && tgcAltError && HasICengapprovedvalue
                && (MatchSRA(currentView) || userHasAccessToSubmit) && !getAltDeleteIconStatus() && !getAftDeleteIconStatus()}
            footerButtonText={conditionalValueSelector(MatchSRA(currentView), 'Mandatory P8-1', 'Submit')}
            widerFooter={widerFooter}
            height={displayForm ? 'calc(100vh - 168px)' : 'calc(100vh - 150px)'}
            goBack={goBackValue}
            isDisabled={disableSubmit}
        >
            {(showTagMoNotExist || isLateEntryTrfAlredySubmited) && (
                <AlertDialog
                    dialogMessage={isLateEntryTrfAlredySubmited ? 'Tag & MO number combination has previously been submitted.' : 'Invalid Tag or MO number. Please enter a valid Tag & MO number combination from SAP.'}
                    dialogOpenState={showTagMoNotExist}
                    handleAlertFunction={() => handleLateentryFlocMoNotExist()}
                    isLateEntrySaflocExist={isLateEntrySaflocExist}
                />
            )}
            {showTagMoExist && (
                <AlertDialog
                    dialogMessage="Cannot proceed with Late Entry submission for this record is currently open. Please submit this TRF using Classic MRAT feature."
                    dialogOpenState={showTagMoExist}
                    handleAlertFunction={() => handleLateentryFlocMoExist()}
                    isLateEntrylastFlowDate={isLateEntrylastFlowDate}
                />
            )}
            {showDpsTfrSwitchAlert && isLateEntryInvalidTrf && (
                <AlertDialog
                    dialogMessage={`The selected Tag number has been assigned to ${selectDpsTRFDataLateEntry.TrfId}. Do you want to switch the TRF?`}
                    dialogOpenState={showDpsTfrSwitchAlert}
                    handleClose={() => handleLateentryDpsNo()}
                    handleAlertFunction={() => handleLateentryDpsYes()}
                />
            )}
            {deleteWarning && (
                <AlertDialog
                    dialogMessage="Do you want to continue with the Delete?"
                    dialogOpenState={deleteWarning}
                    handleClose={() => handleNo()}
                    handleAlertFunction={() => handleYes()}
                />
            )}
            {showDraftAlert && (
                <DraftAlert
                    dialogOpenState={showDraftAlert}
                    handleClose={() => setShowDraftAlert(false)}
                    handleAlertFunction={(notice) => draftHandler(notice)}
                />
            )}
            <DarkBackground disappear={!spinnerVisible}>
                <Spinner />
            </DarkBackground>
            {displayForm ? (
                <form id={formName} style={{ margin: '1rem' }}>
                    {React.Children.map(props.children, child => {
                        if (React.isValidElement(child)) {
                            return React.cloneElement(child, {
                                formData: formDataObj,
                                changeHandler,
                                formName,
                                dpsData,
                                isFormReadOnly,
                                updateFormData,
                                aftTestPoint,
                                altTestPoint,
                                flowAlarmTestPoint
                            });
                        }
                        return child;
                    })}
                </form>
            )
                : (
                    <Camera
                        selectedTag={selectedTag}
                        formData={formData}
                        capturedImages={getCapturedImg}
                        getImages={getImages}
                        updatedFormDataTag={updatedFormDataTag.F2SapFloc}
                        nonMoNumber={selectedTag.HdWorkOrder || formDataObj.F20Mo || uniqueMoNumber}
                        readOnly={isFormReadOnly}
                    />
                )}
        </SiteWrapper>
    );
};

const mapStateToProps = ({ TestEquipment, Home, Forms, AppData, SavedTRF, DPS }) => ({
    aftTestPoint: Forms.aftTestPoint,
    altTestPoint: Forms.altTestPoint,
    currentView: Home.currentView,
    selectedTag: Forms.selectedTag,
    formData: Forms.formData,
    formDataP81: Forms.formDataP81,
    formDataSRA: Forms.formDataSRA,
    deleteExistingImageList: Forms.deleteExistingImageList,
    deleteNewImageList: Forms.deleteNewImageList,
    dpsData: Forms.dpsData,
    testMakeModelData: TestEquipment.testEquipmentDataAll,
    sortColumn: TestEquipment.sortColumn,
    editedImageList: Forms.editedImageList,
    selectedTrfId: Forms.selectedTrfId,
    userRole: Home.userRole,
    totalCount: Forms.totalCount,
    trfFormImage: Forms.trfFormImage,
    workType: Home.selectedWorkType,
    trfMasterList: Home.trfMasterList,
    multiTRFDetails: Forms.multiTRFDetails,
    getMultiTRFDetails: Forms.getMultiTRFDetails,
    flowAlarmTestPoint: Forms.flowAlarmTestPoint,
    spinnerVisible: Forms.spinnerVisible,
    draftStatus: Home.draftStatus,
    isMRATOnline: AppData.isMRATOnline,
    draftDuration: Home.draftDuration,
    bpRegionNameAlias: Home.bpRegionNameAlias,
    selectedAssetAliasName: Home.selectedAssetAliasName,
    searchStringForTestEq: TestEquipment.searchStringForTestEq,
    sortDeviceTypeAscOrder: TestEquipment.sortDeviceTypeAscOrder,
    sortStatusAscOrder: TestEquipment.sortStatusAscOrder,
    updatedFormDataTag: Forms.updatedFormDataObj,
    previousScreen: Home.previousScreen,
    updatedFormDataObj: Forms.updatedFormDataObj,
    IsLateEntry: Home.IsLateEntry,
    dpsSelectedFormData: Forms.dpsSelectedFormData,
    dpsDataAll: DPS.dpsDataAll,
    isLateEntrySaflocExist: Forms.isLateEntrySaflocExist,
    isLateEntrylastFlowDate: Forms.isLateEntrylastFlowDate,
    isLateEntryInvalidTrf: Forms.isLateEntryInvalidTrf,
    isLateEntryTrfAlredySubmited: Forms.isLateEntryTrfAlredySubmited,
    lateEntrySwitchData: Forms.lateEntrySwitchData,
});

const mapDispatchToProps = dispatch => ({
    dispatch,
    loadP8ITFForm: ({ uniqueFormName, HdLocation, currentTrfId }) => dispatch(GetP8ITFForm({ uniqueFormName, HdLocation, currentTrfId })),
    loadITFForm: ({ uniqueFormName, HdLocation, currentTrfId }) => dispatch(GetITFForm({ uniqueFormName, HdLocation, currentTrfId })),
    resetFormDataValues: () => dispatch(resetFormData()),
    fetchTestEquipmentData: () => dispatch(getTestMakeModelData()),
    searchTestEquipmentRecords: (searchVal) => dispatch(searchTestEquipment(searchVal)),
    setPreviousAppScreen: (screen) => dispatch(setPreviousScreen(screen)),
    setCurrentAppView: (view) => dispatch(setCurrentView(view)),
    saveP81FormData: (formData) => dispatch(setP81FormData(formData)),
    saveSRAFormData: (formData) => dispatch(setSRAFormData(formData)),
    saveExistingFormOnlineOrOffline: (formName, formData, trfId, userName) => dispatch(submitExistingFormOnlineOrOffline(formName, formData, trfId, userName)),
    saveNewFormOnlineOrOffline: (formName, formData, trfId, userName) => dispatch(submitNewFormOnlineOrOffline(formName, formData, trfId, userName)),
    saveTRFImage: (imgData, userName, uniqueFormName, imgDraftState, imgNonMoState, floc, imgLateEntryState) => dispatch(submitNewTRFImage(imgData, userName, uniqueFormName, imgDraftState, imgNonMoState, floc, imgLateEntryState)),
    updateTRFImage: (imgData, userName, uniqueFormName, imgDraftState, imgNonMoState, imgLateEntryState) => dispatch(updateExistingTRFImage(imgData, userName, uniqueFormName, imgDraftState, imgNonMoState, imgLateEntryState)),
    saveP8TRFImage: (imgData, userName, uniqueFormName, imgNonMoState, imgLateEntryState) => dispatch(submitNewP8TRFImage(imgData, userName, uniqueFormName, imgNonMoState, imgLateEntryState)),
    updateAftTestPointRangePrevVal: (testPoint) => dispatch(saveAftTestPointRangePrevVal(testPoint)),
    updateAltTestPointRangePrevVal: (testPoint) => dispatch(saveAltTestPointRangePrevVal(testPoint)),
    updateFlowAlarmTestPointRangePrevVal: (testPoint) => dispatch(saveFlowAlarmTestPointRangePrevVal(testPoint)),
    updateP8TRFImage: (imgData, userName, uniqueFormName, imgNonMoState, imgLateEntryState) => dispatch(updateExistingP8TRFImage(imgData, userName, uniqueFormName, imgNonMoState, imgLateEntryState)),
    updateimageNote: () => dispatch(updateImageNote()),
    setIsEditImages: (isEdit, img) => dispatch(setIsEditimage(isEdit, img)),
    saveUpdatedFormDataObj: (formData) => dispatch(UpdateFormDataObj(formData)),
    clearEditimageList: () => dispatch(clearEditImageList()),
    setSpinnerVisible: (spinnerValue) => dispatch(saveSpinnerVisibleData(spinnerValue)),
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Form);

Form.propTypes = {
    aftTestPoint: PropTypes.number,
    altTestPoint: PropTypes.number,
    bpRegionNameAlias: PropTypes.string,
    children: PropTypes.array,
    clearEditimageList: PropTypes.func,
    currentView: PropTypes.string,
    deleteExistingImageList: PropTypes.array,
    deleteNewImageList: PropTypes.array,
    dispatch: PropTypes.any,
    dpsData: PropTypes.object,
    dpsDataAll: PropTypes.object,
    dpsSelectedFormData: PropTypes.object,
    draftDuration: PropTypes.number,
    draftStatus: PropTypes.bool,
    editedImageList: PropTypes.array,
    fetchTestEquipmentData: PropTypes.func,
    flowAlarmTestPoint: PropTypes.number,
    formData: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.object
    ]),
    formDataP81: PropTypes.object,
    formDataSRA: PropTypes.object,
    formName: PropTypes.string,
    IsLateEntry: PropTypes.bool,
    isLateEntryInvalidTrf: PropTypes.bool,
    isLateEntrylastFlowDate: PropTypes.bool,
    isLateEntrySaflocExist: PropTypes.bool,
    isLateEntryTrfAlredySubmited: PropTypes.bool,
    isMRATOnline: PropTypes.bool,
    lateEntrySwitchData: PropTypes.object,
    loadITFForm: PropTypes.func,
    loadP8ITFForm: PropTypes.func,
    Mi: PropTypes.string,
    multiTRFDetails: PropTypes.array,
    previousScreen: PropTypes.string,
    resetFormDataValues: PropTypes.func,
    saveExistingFormOnlineOrOffline: PropTypes.func,
    saveNewFormOnlineOrOffline: PropTypes.func,
    saveP81FormData: PropTypes.func,
    saveP8TRFImage: PropTypes.func,
    saveSRAFormData: PropTypes.func,
    saveTRFImage: PropTypes.func,
    saveUpdatedFormDataObj: PropTypes.func,
    searchStringForTestEq: PropTypes.string,
    searchTestEquipmentRecords: PropTypes.func,
    selectedAssetAliasName: PropTypes.string,
    selectedTag: PropTypes.object,
    selectedTrfId: PropTypes.string,
    setCurrentAppView: PropTypes.func,
    setIsEditImages: PropTypes.func,
    setPreviousAppScreen: PropTypes.func,
    setSortedTestEquipmentView: PropTypes.func,
    setSpinnerVisible: PropTypes.func,
    sortColumn: PropTypes.string,
    sortDeviceTypeAscOrder: PropTypes.bool,
    sortStatusAscOrder: PropTypes.bool,
    spinnerVisible: PropTypes.bool,
    testMakeModelData: PropTypes.array,
    totalCount: PropTypes.number,
    trfFormImage: PropTypes.array,
    trfMasterList: PropTypes.array,
    updateAftTestPointRangePrevVal: PropTypes.func,
    updateAltTestPointRangePrevVal: PropTypes.func,
    updatedFormDataObj: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.object
    ]),
    updatedFormDataTag: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.object
    ]),
    updateFlowAlarmTestPointRangePrevVal: PropTypes.func,
    updateimageNote: PropTypes.func,
    updateP8TRFImage: PropTypes.func,
    updateTRFImage: PropTypes.func,
    userRole: PropTypes.string,
    workType: PropTypes.string
};
